import React, { useId } from 'react';
import { InfraHexClusterSvg } from '../diagrams/InfraHexCluster';
import { LabsDiagramDefs, LabsDiagramBody } from '../diagrams/LabsDiagramGraphic';
import { OntologyDiagramDefs, OntologyDiagramBody } from '../diagrams/OntologyDiagramGraphic';
import { PlatformHubDiagramSvg } from '../diagrams/PlatformHubDiagram';

/** Platform: circle-from-slats mask by default; hover morphs slats into Europe (split/merge, no crossfade). */
export function DiagramPlatform() {
  const uid = useId().replace(/:/g, '');
  return <PlatformHubDiagramSvg uid={uid} aria-hidden="true" />;
}

/** Infra: honeycomb / heat-glow cluster (matches animated hex field on tab). */
export function DiagramInfra() {
  const uid = useId().replace(/:/g, '');
  return <InfraHexClusterSvg uid={uid} aria-hidden="true" />;
}

/** Labs: hex annular mark — same language as Ontology (panels, scooped rim, hub void, inward ticks). */
export function DiagramLabs() {
  const uid = useId().replace(/:/g, '');
  const bgGradientId = `labs-hero-bg-${uid}`;
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <LabsDiagramDefs bgGradientId={bgGradientId} />
      <LabsDiagramBody bgGradientId={bgGradientId} />
    </svg>
  );
}

/**
 * Ontology: warm panel + hub (abstract cross-inspired mark, not a historical symbol).
 */
export function DiagramOntology() {
  const uid = useId().replace(/:/g, '');
  const bgGradientId = `ont-hero-bg-${uid}`;
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <OntologyDiagramDefs bgGradientId={bgGradientId} />
      <OntologyDiagramBody bgGradientId={bgGradientId} />
    </svg>
  );
}
